import script from "./NewNovelCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./NewNovelCreate.vue?vue&type=script&setup=true&lang=js"

import "./NewNovelCreate.vue?vue&type=style&index=0&id=b3f16d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f16d32"]])

export default __exports__